import React, {useEffect, useState} from 'react';
import axios from '../../services/axiosInstance';
import i18n from "../../i18n";
import '../../css/web/AdminPopupSetPg.css';
import {useTranslation} from "react-i18next";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Navigation, Pagination} from "swiper/modules";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";

function UserMainPopModal() {

    const [theme] = useTheme();

    /** region DataSet */

    const [popupData, setPopupData] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(true);

    /** endregion */

    /** region Function */

    const {t} = useTranslation();

    const getFutureDate = (days) => {
        const date = new Date();
        date.setDate(date.getDate() + days);
        return date;
    };

    const handlePopupClose = (days) => {
        const futureDate = getFutureDate(days);
        localStorage.setItem("popupHideUntil", futureDate);
        setIsPopupOpen(false);
    };

    const checkPopupVisibility = () => {
        const now = new Date();
        const popupHide = localStorage.getItem('popupHideUntil');
        if (popupHide && new Date(popupHide) > now) {
            setIsPopupOpen(false);
        }
    };

    /** endregion */

    useEffect(() => {
        const selectPopupData = (lang) => {
            axios.get(`/popup/selectPopupList?lang=${lang}`)
                .then((response) => {
                    const popupData = response.data.map((data) => ({
                        ...data,
                        imageUrl: data?.bannerPopPhotoDTOS?.[0]?.fileNm
                            ? `https://toeloperfile.s3.ap-northeast-2.amazonaws.com/popupImg/${data.bannerPopPhotoDTOS[0].fileNm}`
                            : null
                    }));
                    setPopupData(popupData);
                });
        };

        const handleLanguageChange = (lng) => {
            let lang;
            switch (lng) {
                case 'ko':
                    lang = '0';
                    break;
                case 'en':
                    lang = '1';
                    break;
                case 'ja':
                    lang = '2';
                    break;
                case 'zh':
                    lang = '3';
                    break;
                case 'id':
                    lang = '4';
                    break;
                default:
                    lang = '0';
            }
            selectPopupData(lang.charAt(0));
            checkPopupVisibility();
        };
        i18n.on('languageChanged', handleLanguageChange);
        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, []);

    return (
        <>
            {isPopupOpen && popupData && popupData.length > 0 && (
                <div className="custom-popup-container font-t-cont" data-theme={theme}>
                    {isPopupOpen && popupData.map((popup, index) => (
                        <div className="custom-popup-frame popup-s-frame" key={index}>
                            <div className="c-p-main ht-86pc position-relative">
                                <div className="wd-100pc ht-100pc">
                                    <Swiper
                                        className="scroll-container"
                                        modules={[Autoplay, Pagination, Navigation]}
                                        slidesPerView={1}
                                        loop={true}
                                        centeredSlides={true}
                                        autoplay={{ delay: 1000, disableOnInteraction: false }}
                                        pagination={{
                                            el: '.popup-custom-pagination',
                                            clickable: true,
                                            dynamicBullets: true,
                                        }}
                                        watchOverflow={true}
                                    >
                                        {popupData.map((popup, index) => (
                                            <SwiperSlide key={`popup-slide-${popup.id || index}`}>
                                                <div className="wd-100pc ht-100pc">
                                                    {popup.imageUrl ? (
                                                        <img
                                                            className="wd-100pc ht-100pc"
                                                            src={popup.imageUrl}
                                                            alt={`popup-${index}`}
                                                            style={{
                                                                objectFit: "cover",
                                                                cursor: popup.pimgType === '1' ? 'pointer' : 'default'
                                                            }}
                                                            onClick={() => {
                                                                if (popup.pimgType === '1') {
                                                                    window.open(popup.purl, '_self');
                                                                }
                                                            }}
                                                        />
                                                    ) : (
                                                        <p>Image Error</p>
                                                    )}
                                                </div>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                            </div>
                            <div className="c-p-footer ht-auto display-flex flex-row just-cont-sb gap10 c-def p-t-10 p-r-10 p-b-10 p-l-10 font-s-13" style={{ borderTop: "solid 1px var(--ump-border, #EAEAEA)" }}>
                                <div className="wd-50pc ht-40 text-center align-center-c c-point pop-btn" onClick={() => handlePopupClose(1)}>{t(`popupFooterToday`)}</div>
                                <div className="wd-50pc ht-40 text-center align-center-c c-point pop-btn" onClick={() => handlePopupClose(0)}>{t(`popupFooterClose`)}</div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
}

export default UserMainPopModal
